/* eslint-disable */
const languages = [
  "fr",
  "es",
  "en",
  "pt",
  "ru",
  "de"
] as const;
export default languages;
export type SupportedLanguage = typeof languages[number];
